/* eslint-disable max-len */
import { SvgProps } from './types'

export const BuildingIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_89_5882)">
        <path d="M51.7425 50.2299V9.9856" stroke={drawColor} strokeWidth="2.5" />
        <path d="M25.4386 50.2299V9.9856" stroke={drawColor} strokeWidth="2.5" />
        <path d="M6.61832 28.4726V19.4011" stroke={drawColor} strokeWidth="2.5" />
        <path d="M6.61832 41.3083V33.114" stroke={drawColor} strokeWidth="2.5" />
        <path d="M6.61832 50.2298V45.9495" stroke={drawColor} strokeWidth="2.5" />
        <path
          d="M52.9584 5H24.2283C23.9708 5 23.762 5.20879 23.762 5.46634V9.51908C23.762 9.77664 23.9708 9.98543 24.2283 9.98543H52.9584C53.2159 9.98543 53.4247 9.77664 53.4247 9.51908V5.46634C53.4247 5.20879 53.2159 5 52.9584 5Z"
          stroke={drawColor}
          strokeWidth="2.5"
        />
        <path
          d="M4.81957 14.4158H25.4386V19.4012H4.81957C4.56419 19.4012 4.35323 19.1902 4.35323 18.9349V14.8821C4.35323 14.6267 4.56419 14.4158 4.81957 14.4158Z"
          stroke={drawColor}
          strokeWidth="2.5"
        />
        <path
          d="M12.4865 28.4726V24.0479C12.4865 23.6926 12.7696 23.4094 13.1249 23.4094H18.5489C18.9042 23.4094 19.1874 23.6926 19.1874 24.0479V28.4726"
          stroke={drawColor}
          strokeWidth="2.5"
        />
        <path
          d="M20.8529 28.4727H5.38584C4.81554 28.4727 4.35323 28.935 4.35323 29.5053V32.0868C4.35323 32.6571 4.81554 33.1194 5.38584 33.1194H20.8529C21.4232 33.1194 21.8855 32.6571 21.8855 32.0868V29.5053C21.8855 28.935 21.4232 28.4727 20.8529 28.4727Z"
          stroke={drawColor}
          strokeWidth="2.5"
        />
        <path
          d="M12.4865 41.3083V36.8836C12.4865 36.5283 12.7696 36.2451 13.1249 36.2451H18.5489C18.9042 36.2451 19.1874 36.5283 19.1874 36.8836V41.3083"
          stroke={drawColor}
          strokeWidth="2.5"
        />
        <path
          d="M20.8529 41.3081H5.38584C4.81554 41.3081 4.35323 41.7704 4.35323 42.3407V44.9223C4.35323 45.4926 4.81554 45.9549 5.38584 45.9549H20.8529C21.4232 45.9549 21.8855 45.4926 21.8855 44.9223V42.3407C21.8855 41.7704 21.4232 41.3081 20.8529 41.3081Z"
          stroke={drawColor}
          strokeWidth="2.5"
        />
        <path d="M45.0638 13.5442H32.1228V22.4935H45.0638V13.5442Z" stroke={drawColor} strokeWidth="2.5" />
        <path d="M45.0638 25.9521H32.1228V34.9015H45.0638V25.9521Z" stroke={drawColor} strokeWidth="2.5" />
        <path d="M43.415 40.0481H33.7661V50.2244H43.415V40.0481Z" stroke={drawColor} strokeWidth="2.5" />
        <path d="M38.5906 40.0481V50.2299" stroke={drawColor} strokeWidth="2.5" />
        <path d="M32.1228 31.4485H45.0638" stroke={drawColor} strokeWidth="2.5" />
        <path d="M32.1228 19.4011H44.8418" stroke={drawColor} strokeWidth="2.5" />
        <path d="M1 50.2297H55.5232" stroke={drawColor} strokeWidth="2.5" />
      </g>
      <defs>
        <clipPath id="clip0_89_5882">
          <rect width="56" height="56" fill="white" transform="translate(0.25 0.0200195)" />
        </clipPath>
      </defs>
    </svg>
  )
}
